export default __webpack_public_path__ + "static/peg-9f067d8918eb39d97fe2f4ca625c9dfc.png";